import { alpha, SxProps, Theme } from '@mui/material';

export const getLocalExternalIdEntrySx = (theme: Theme): SxProps<Theme> => ({
  bgcolor: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.16 : 0.08),
  borderLeft: '3px solid',
  borderColor: 'primary.main',
});
